import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { BET_SLIP_TABS, ERROR_CODES } from '../../../constants/defaultValues';
import BetSlipError from '../BetSlipError/BetSlipError';
import { getTranslation } from '../../../utils/translation';
import { sprintf } from 'sprintf-js';

const Validations = () => {
    const validations = useSelector(state => state.betSlip.validations);
    const placedBetErrors = useSelector(state => state.betSlip.placedBetErrors);
    const activeTab = useSelector(state => state.betSlip.activeTab);

    const renderValidations = () => {
        let renderedItems = [];

        switch (activeTab) {
            case BET_SLIP_TABS.single.id: {
                renderedItems = validations.single.map(validation => {
                    return (
                        <BetSlipError
                            key={validation.key}
                            type={validation.type}
                            description={validation.message}
                        />
                    );
                });
                break;
            }
            case BET_SLIP_TABS.combo.id: {
                renderedItems = validations.combo.map(validation => {
                    return (
                        <BetSlipError
                            key={validation.key}
                            type={validation.type}
                            description={validation.message}
                        />
                    );
                });
                break;
            }
            case BET_SLIP_TABS.system.id: {
                renderedItems = validations.system.map(validation => {
                    return (
                        <BetSlipError
                            key={validation.key}
                            type={validation.type}
                            description={validation.message}
                        />
                    );
                });
                break;
            }
            default: {
                renderedItems = [];
            }
        }

        renderedItems.push(
            validations.common.map(validation => {
                return (
                    <BetSlipError
                        key={validation.key}
                        type={validation.type}
                        description={validation.message}
                    />
                );
            })
        );

        if (placedBetErrors.length > 0) {
            renderedItems.push(
                placedBetErrors.map(error => (
                    <BetSlipError
                        key={error.code}
                        type='error'
                        description={getErrorDescription(error)}
                    />
                ))
            );
        }

        return renderedItems;
    };

    const getErrorDescription = error =>
        error.code === ERROR_CODES.duplicateTicketCode
            ? sprintf(getTranslation('duplicateTicketCodeError'), { code: error.code })
            : error.reason;

    return <Fragment>{renderValidations()}</Fragment>;
};

export default Validations;
